export default {
      id: "chassis_loaded-usage",
      viewBox: "0 0 39 24",
      url: __webpack_public_path__ + "img/icons.svg#chassis_loaded",
      toString: function () {
        return this.url;
      }
    }